import { __assign } from "tslib";
import * as React from 'react';
var SvgCross = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("path", { d: "M0 0h24v24H0z" }),
        React.createElement("path", { fill: "#6A6E72", d: "M9.834 10.95l5.391-5.392a.625.625 0 1 1 .884.884l-5.391 5.392 5.391 5.391a.625.625 0 1 1-.884.884l-5.391-5.391-5.392 5.391a.625.625 0 1 1-.884-.884l5.392-5.391-5.392-5.392a.625.625 0 0 1 .884-.884l5.392 5.392z" })))); };
export default SvgCross;
//# sourceMappingURL=Cross.js.map